const boxStyles = {
  // border: 1,
  // borderColor: "lightgrey",
  px: 5,
  pt: 1,
  pb: 5,
  borderRadius: 3,
  display: "block",
  backgroundColor: "#fff",
};

export default boxStyles;
